/**
 * @generated SignedSource<<3a77a0e0e76cf201d161e3a483639545>>
 * @relayHash bc9ac9eab0f102579b7d3474e491e74a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7894a1692bf666dbbd78dcc280839b57fa334fa2240f164c9032dffbb900128

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainCompleteSprintMetadataQuery } from './mainCompleteSprintMetadataQuery.graphql';

const node: PreloadableConcreteRequest<mainCompleteSprintMetadataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d7894a1692bf666dbbd78dcc280839b57fa334fa2240f164c9032dffbb900128",
    "metadata": {},
    "name": "mainCompleteSprintMetadataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
